
import { Skeleton, Card, Col, Row } from "antd";

const DashboardCardLoader = () => {
  return (
    <Row gutter={[20, 20]}>
      {[...Array(4)].map((_, index) => (
        <Col
          key={index}
          xs={24}
          sm={12}
          md={12}
          lg={6} // 6/24 = 25%
        >
          <Card
            style={{
              borderRadius: 15,
              padding: 0,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              width: "18vw"
            }}
            bodyStyle={{ padding: 4 }}
          >
            <Skeleton
              active
              paragraph={{ rows: 1 }}
              title={{ width: "80%" }}
              avatar={{ shape: "circle", size: "large" }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardCardLoader;
